var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#01313D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.20628 11.7609L13.4978 6.25656C13.6622 6.08552 13.8714 6 14.1256 6C14.3797 6 14.5889 6.08552 14.7534 6.25656C14.9178 6.4276 15 6.64529 15 6.90962C15 7.17395 14.9178 7.39164 14.7534 7.56268L8.83408 13.7201C8.65471 13.9067 8.44544 14 8.20628 14C7.96711 14 7.75785 13.9067 7.57848 13.7201L5.24664 11.2945C5.08221 11.1234 5 10.9057 5 10.6414C5 10.3771 5.08221 10.1594 5.24664 9.98834C5.41106 9.8173 5.62033 9.73178 5.87444 9.73178C6.12855 9.73178 6.33782 9.8173 6.50224 9.98834L8.20628 11.7609Z",
    fill: "#FAF2E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.d95f47179a68f309f80f8d21c32afe87.svg";
export { ForwardRef as ReactComponent };